// 할인 링크가 지금 열려 있는지. 서버 campaignPeriodState(fundingPricing.js)와 같은 규칙으로, 날짜가 아니라 시각으로 본다.
// openAt·closeAt 은 서버가 정확한 시각(ISO)으로 보낸다(/api/promotion/select/code). 값이 없으면 그쪽 끝은 막지 않는다.
// 관리자 화면은 링크종료일을 날짜만(한국 0시) 저장한다. 그 값은 예전처럼 그날 끝까지 연다(10/15 검수: 마지막 날이 사라질 뻔함).
const DAY = 24 * 60 * 60 * 1000
const KST = 9 * 60 * 60 * 1000

function isPromotionLinkOpen(promotion, now) {
  if (!promotion) return true
  const at = now == null ? Date.now() : new Date(now).getTime()
  const opens = promotion.openAt ? new Date(promotion.openAt).getTime() : NaN
  let closes = promotion.closeAt ? new Date(promotion.closeAt).getTime() : NaN
  if (!Number.isNaN(closes) && (closes + KST) % DAY === 0) closes += DAY - 1
  if (!Number.isNaN(opens) && at < opens) return false
  if (!Number.isNaN(closes) && at > closes) return false
  return true
}
module.exports = { isPromotionLinkOpen }
